// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-content-stats {
    flex-grow: 1;
}

.stats-search-filters {
    border: 1px solid #ddd;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 5px;
}

.stats-search-filters .filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 10px;
}

.stats-search-filters .filter-row:last-child {
    margin-bottom: 0;
}

.stats-search-filters .filter-row label {
    width: 100px;
    font-weight: bold;
    flex-shrink: 0;
}

.stats-search-filters .filter-select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 200px;
}

.stats-search-filters .filter-input-date {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.stats-search-filters .filter-checkboxes {
    display: flex;
    gap: 20px;
}

.stats-search-filters .filter-checkboxes label {
    display: flex;
    align-items: center;
    gap: 5px;
    width: auto;
}

.search-button-stats {
    display: block;
    width: 343px;
    padding: 15px;
    background-color: #222;
    color: white;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 30px auto;
}

.stats-data-container {
    margin-top: 30px;
}

.stats-data-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.stats-data-header span {
    font-size: 16px;
    font-weight: bold;
}

.stats-data-header .btn-excel-download {
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}

.stats-table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #333;
}

.stats-table th,
.stats-table td {
    text-align: center;
    padding: 15px 10px;
    border-bottom: 1px solid #ddd;
}

.stats-table th {
    font-weight: bold;
    background-color: #f8f9fa;
}

.stats-table .progress-bar-cell {
    width: 35%;
}

.progress-bar-container {
    width: 100%;
    background-color: #f0f0f0;
    border-radius: 5px;
    overflow: hidden;
    height: 20px;
}

.progress-bar {
    height: 100%;
    background-color: #e84118;
    border-radius: 5px 0 0 5px;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .stats-search-filters .filter-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
    
    .stats-search-filters .filter-row label {
        width: 100%;
    }

    .stats-search-filters .filter-select,
    .stats-search-filters .filter-input-date {
        width: 100%;
    }
    
    .search-button-stats {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .stats-table thead {
        display: none;
    }

    .stats-table, .stats-table tbody, .stats-table tr, .stats-table td {
        display: block;
        width: 100%;
    }

    .stats-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }

    .stats-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
    }
    
    .stats-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
    
    .stats-table .progress-bar-cell {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/StatsPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,+BAA+B;AAC/B;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".admin-content-stats {\n    flex-grow: 1;\n}\n\n.stats-search-filters {\n    border: 1px solid #ddd;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n}\n\n.stats-search-filters .filter-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    gap: 10px;\n}\n\n.stats-search-filters .filter-row:last-child {\n    margin-bottom: 0;\n}\n\n.stats-search-filters .filter-row label {\n    width: 100px;\n    font-weight: bold;\n    flex-shrink: 0;\n}\n\n.stats-search-filters .filter-select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 200px;\n}\n\n.stats-search-filters .filter-input-date {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.stats-search-filters .filter-checkboxes {\n    display: flex;\n    gap: 20px;\n}\n\n.stats-search-filters .filter-checkboxes label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    width: auto;\n}\n\n.search-button-stats {\n    display: block;\n    width: 343px;\n    padding: 15px;\n    background-color: #222;\n    color: white;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin: 30px auto;\n}\n\n.stats-data-container {\n    margin-top: 30px;\n}\n\n.stats-data-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.stats-data-header span {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.stats-data-header .btn-excel-download {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.stats-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-top: 2px solid #333;\n}\n\n.stats-table th,\n.stats-table td {\n    text-align: center;\n    padding: 15px 10px;\n    border-bottom: 1px solid #ddd;\n}\n\n.stats-table th {\n    font-weight: bold;\n    background-color: #f8f9fa;\n}\n\n.stats-table .progress-bar-cell {\n    width: 35%;\n}\n\n.progress-bar-container {\n    width: 100%;\n    background-color: #f0f0f0;\n    border-radius: 5px;\n    overflow: hidden;\n    height: 20px;\n}\n\n.progress-bar {\n    height: 100%;\n    background-color: #e84118;\n    border-radius: 5px 0 0 5px;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .stats-search-filters .filter-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n    \n    .stats-search-filters .filter-row label {\n        width: 100%;\n    }\n\n    .stats-search-filters .filter-select,\n    .stats-search-filters .filter-input-date {\n        width: 100%;\n    }\n    \n    .search-button-stats {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .stats-table thead {\n        display: none;\n    }\n\n    .stats-table, .stats-table tbody, .stats-table tr, .stats-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .stats-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        overflow: hidden;\n    }\n\n    .stats-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n    }\n    \n    .stats-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n    \n    .stats-table .progress-bar-cell {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
